import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function StarOutline(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M10.654 2.47c.55-1.117 2.142-1.117 2.692 0l2.419 4.916 5.366.778c1.235.179 1.724 1.701.823 2.566l-3.878 3.723.937 5.384c.212 1.221-1.065 2.159-2.166 1.59L12 18.925l-4.847 2.502c-1.102.569-2.378-.369-2.166-1.59l.937-5.384-3.878-3.723c-.901-.865-.413-2.387.823-2.566l5.366-.778 2.42-4.916zM12 4.265L9.797 8.742a1 1 0 01-.754.548l-4.874.706 3.524 3.383a1 1 0 01.292.892l-.855 4.917 4.411-2.277a1 1 0 01.918 0l4.41 2.277-.854-4.917a1 1 0 01.293-.892l3.523-3.383-4.874-.706a1 1 0 01-.754-.548L12 4.264z",
    clipRule: "evenodd"
  }));
}

export default StarOutline;